<template>
  <div class="market-giftCouponRecord-index">
    <el-tabs v-model="tabsKey" type="card" :closable="false" :before-leave="onTabClick" >
      <el-tab-pane label="停车券记录">
        <div class="tab-content">
          <BuyRecord></BuyRecord>
        </div>
      </el-tab-pane>
      <el-tab-pane label="手动发券明细">
        <div class="tab-content">
          <GrantRecord></GrantRecord>
        </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script>
import BuyRecord from './couponBuyRecord'
import GrantRecord from './couponGrantRecord'
export default {
  name: "mGiftCouponRecordIndex",
  components: {
    BuyRecord,
    GrantRecord
  },
  data() {
    return {
      tabsKey: 0
    };
  },
  created () {
  },
  methods: {
    onTabClick() {

    }
  },
  watch: {
  },
  computed: {},
};
</script>
<style lang="scss" scoped>
.market-giftCouponRecord-index {
  width: 100%;
  padding: 35px 20px;
  box-sizing: border-box;

  .tab-content {
    margin-top: -30px;
  }
}
</style>
